export const locale = {
    lang: 'en',
    data: {
        ADD: 'Add paragraph',
        TITLE: 'Title',
        SAVE: 'Save',
        CANCEL: 'Cancel',
    }
};
